"use strict";
/**
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*! THIS FILE IS AUTO-GENERATED */

var googleapis_1 = require("./googleapis");

exports.GoogleApis = googleapis_1.GoogleApis;
var google = new googleapis_1.GoogleApis();
exports.google = google;

var v1_1 = require("./apis/abusiveexperiencereport/v1");

exports.abusiveexperiencereport_v1 = v1_1.abusiveexperiencereport_v1;

var v1_2 = require("./apis/acceleratedmobilepageurl/v1");

exports.acceleratedmobilepageurl_v1 = v1_2.acceleratedmobilepageurl_v1;

var v1beta1_1 = require("./apis/accessapproval/v1beta1");

exports.accessapproval_v1beta1 = v1beta1_1.accessapproval_v1beta1;

var v1_3 = require("./apis/accesscontextmanager/v1");

exports.accesscontextmanager_v1 = v1_3.accesscontextmanager_v1;

var v1beta_1 = require("./apis/accesscontextmanager/v1beta");

exports.accesscontextmanager_v1beta = v1beta_1.accesscontextmanager_v1beta;

var v1_2_1 = require("./apis/adexchangebuyer/v1.2");

exports.adexchangebuyer_v1_2 = v1_2_1.adexchangebuyer_v1_2;

var v1_3_1 = require("./apis/adexchangebuyer/v1.3");

exports.adexchangebuyer_v1_3 = v1_3_1.adexchangebuyer_v1_3;

var v1_4_1 = require("./apis/adexchangebuyer/v1.4");

exports.adexchangebuyer_v1_4 = v1_4_1.adexchangebuyer_v1_4;

var v2beta1_1 = require("./apis/adexchangebuyer2/v2beta1");

exports.adexchangebuyer2_v2beta1 = v2beta1_1.adexchangebuyer2_v2beta1;

var v1_4 = require("./apis/adexperiencereport/v1");

exports.adexperiencereport_v1 = v1_4.adexperiencereport_v1;

var datatransfer_v1_1 = require("./apis/admin/datatransfer_v1");

exports.admin_datatransfer_v1 = datatransfer_v1_1.admin_datatransfer_v1;

var directory_v1_1 = require("./apis/admin/directory_v1");

exports.admin_directory_v1 = directory_v1_1.admin_directory_v1;

var reports_v1_1 = require("./apis/admin/reports_v1");

exports.admin_reports_v1 = reports_v1_1.admin_reports_v1;

var v1_4_2 = require("./apis/adsense/v1.4");

exports.adsense_v1_4 = v1_4_2.adsense_v1_4;

var v4_1_1 = require("./apis/adsensehost/v4.1");

exports.adsensehost_v4_1 = v4_1_1.adsensehost_v4_1;

var v1beta1_2 = require("./apis/alertcenter/v1beta1");

exports.alertcenter_v1beta1 = v1beta1_2.alertcenter_v1beta1;

var v2_4_1 = require("./apis/analytics/v2.4");

exports.analytics_v2_4 = v2_4_1.analytics_v2_4;

var v3_1 = require("./apis/analytics/v3");

exports.analytics_v3 = v3_1.analytics_v3;

var v4_1 = require("./apis/analyticsreporting/v4");

exports.analyticsreporting_v4 = v4_1.analyticsreporting_v4;

var v1_5 = require("./apis/androiddeviceprovisioning/v1");

exports.androiddeviceprovisioning_v1 = v1_5.androiddeviceprovisioning_v1;

var v1_6 = require("./apis/androidenterprise/v1");

exports.androidenterprise_v1 = v1_6.androidenterprise_v1;

var v1_7 = require("./apis/androidmanagement/v1");

exports.androidmanagement_v1 = v1_7.androidmanagement_v1;

var v1_1_1 = require("./apis/androidpublisher/v1.1");

exports.androidpublisher_v1_1 = v1_1_1.androidpublisher_v1_1;

var v1_8 = require("./apis/androidpublisher/v1");

exports.androidpublisher_v1 = v1_8.androidpublisher_v1;

var v2_1 = require("./apis/androidpublisher/v2");

exports.androidpublisher_v2 = v2_1.androidpublisher_v2;

var v3_2 = require("./apis/androidpublisher/v3");

exports.androidpublisher_v3 = v3_2.androidpublisher_v3;

var v1_9 = require("./apis/appengine/v1");

exports.appengine_v1 = v1_9.appengine_v1;

var v1alpha_1 = require("./apis/appengine/v1alpha");

exports.appengine_v1alpha = v1alpha_1.appengine_v1alpha;

var v1beta_2 = require("./apis/appengine/v1beta");

exports.appengine_v1beta = v1beta_2.appengine_v1beta;

var v1_10 = require("./apis/appsactivity/v1");

exports.appsactivity_v1 = v1_10.appsactivity_v1;

var v2_2 = require("./apis/bigquery/v2");

exports.bigquery_v2 = v2_2.bigquery_v2;

var v1beta1_3 = require("./apis/bigqueryconnection/v1beta1");

exports.bigqueryconnection_v1beta1 = v1beta1_3.bigqueryconnection_v1beta1;

var v1_11 = require("./apis/bigquerydatatransfer/v1");

exports.bigquerydatatransfer_v1 = v1_11.bigquerydatatransfer_v1;

var v1_12 = require("./apis/bigqueryreservation/v1");

exports.bigqueryreservation_v1 = v1_12.bigqueryreservation_v1;

var v1alpha2_1 = require("./apis/bigqueryreservation/v1alpha2");

exports.bigqueryreservation_v1alpha2 = v1alpha2_1.bigqueryreservation_v1alpha2;

var v1beta1_4 = require("./apis/bigqueryreservation/v1beta1");

exports.bigqueryreservation_v1beta1 = v1beta1_4.bigqueryreservation_v1beta1;

var v1_13 = require("./apis/bigtableadmin/v1");

exports.bigtableadmin_v1 = v1_13.bigtableadmin_v1;

var v2_3 = require("./apis/bigtableadmin/v2");

exports.bigtableadmin_v2 = v2_3.bigtableadmin_v2;

var v1_14 = require("./apis/binaryauthorization/v1");

exports.binaryauthorization_v1 = v1_14.binaryauthorization_v1;

var v1beta1_5 = require("./apis/binaryauthorization/v1beta1");

exports.binaryauthorization_v1beta1 = v1beta1_5.binaryauthorization_v1beta1;

var v2_4 = require("./apis/blogger/v2");

exports.blogger_v2 = v2_4.blogger_v2;

var v3_3 = require("./apis/blogger/v3");

exports.blogger_v3 = v3_3.blogger_v3;

var v1_15 = require("./apis/books/v1");

exports.books_v1 = v1_15.books_v1;

var v3_4 = require("./apis/calendar/v3");

exports.calendar_v3 = v3_4.calendar_v3;

var v1_16 = require("./apis/chat/v1");

exports.chat_v1 = v1_16.chat_v1;

var v2_5 = require("./apis/civicinfo/v2");

exports.civicinfo_v2 = v2_5.civicinfo_v2;

var v1_17 = require("./apis/classroom/v1");

exports.classroom_v1 = v1_17.classroom_v1;

var v1_18 = require("./apis/cloudasset/v1");

exports.cloudasset_v1 = v1_18.cloudasset_v1;

var v1beta1_6 = require("./apis/cloudasset/v1beta1");

exports.cloudasset_v1beta1 = v1beta1_6.cloudasset_v1beta1;

var v1_19 = require("./apis/cloudbilling/v1");

exports.cloudbilling_v1 = v1_19.cloudbilling_v1;

var v1_20 = require("./apis/cloudbuild/v1");

exports.cloudbuild_v1 = v1_20.cloudbuild_v1;

var v1alpha1_1 = require("./apis/cloudbuild/v1alpha1");

exports.cloudbuild_v1alpha1 = v1alpha1_1.cloudbuild_v1alpha1;

var v2_6 = require("./apis/clouddebugger/v2");

exports.clouddebugger_v2 = v2_6.clouddebugger_v2;

var v1beta1_7 = require("./apis/clouderrorreporting/v1beta1");

exports.clouderrorreporting_v1beta1 = v1beta1_7.clouderrorreporting_v1beta1;

var v1_21 = require("./apis/cloudfunctions/v1");

exports.cloudfunctions_v1 = v1_21.cloudfunctions_v1;

var v1beta2_1 = require("./apis/cloudfunctions/v1beta2");

exports.cloudfunctions_v1beta2 = v1beta2_1.cloudfunctions_v1beta2;

var v1_22 = require("./apis/cloudidentity/v1");

exports.cloudidentity_v1 = v1_22.cloudidentity_v1;

var v1beta1_8 = require("./apis/cloudidentity/v1beta1");

exports.cloudidentity_v1beta1 = v1beta1_8.cloudidentity_v1beta1;

var v1_23 = require("./apis/cloudiot/v1");

exports.cloudiot_v1 = v1_23.cloudiot_v1;

var v1_24 = require("./apis/cloudkms/v1");

exports.cloudkms_v1 = v1_24.cloudkms_v1;

var v1beta1_9 = require("./apis/cloudprivatecatalog/v1beta1");

exports.cloudprivatecatalog_v1beta1 = v1beta1_9.cloudprivatecatalog_v1beta1;

var v1beta1_10 = require("./apis/cloudprivatecatalogproducer/v1beta1");

exports.cloudprivatecatalogproducer_v1beta1 = v1beta1_10.cloudprivatecatalogproducer_v1beta1;

var v2_7 = require("./apis/cloudprofiler/v2");

exports.cloudprofiler_v2 = v2_7.cloudprofiler_v2;

var v1_25 = require("./apis/cloudresourcemanager/v1");

exports.cloudresourcemanager_v1 = v1_25.cloudresourcemanager_v1;

var v1beta1_11 = require("./apis/cloudresourcemanager/v1beta1");

exports.cloudresourcemanager_v1beta1 = v1beta1_11.cloudresourcemanager_v1beta1;

var v2_8 = require("./apis/cloudresourcemanager/v2");

exports.cloudresourcemanager_v2 = v2_8.cloudresourcemanager_v2;

var v2beta1_2 = require("./apis/cloudresourcemanager/v2beta1");

exports.cloudresourcemanager_v2beta1 = v2beta1_2.cloudresourcemanager_v2beta1;

var v1_26 = require("./apis/cloudscheduler/v1");

exports.cloudscheduler_v1 = v1_26.cloudscheduler_v1;

var v1beta1_12 = require("./apis/cloudscheduler/v1beta1");

exports.cloudscheduler_v1beta1 = v1beta1_12.cloudscheduler_v1beta1;

var v1_27 = require("./apis/cloudsearch/v1");

exports.cloudsearch_v1 = v1_27.cloudsearch_v1;

var v1_28 = require("./apis/cloudshell/v1");

exports.cloudshell_v1 = v1_28.cloudshell_v1;

var v1alpha1_2 = require("./apis/cloudshell/v1alpha1");

exports.cloudshell_v1alpha1 = v1alpha1_2.cloudshell_v1alpha1;

var v2_9 = require("./apis/cloudtasks/v2");

exports.cloudtasks_v2 = v2_9.cloudtasks_v2;

var v2beta2_1 = require("./apis/cloudtasks/v2beta2");

exports.cloudtasks_v2beta2 = v2beta2_1.cloudtasks_v2beta2;

var v2beta3_1 = require("./apis/cloudtasks/v2beta3");

exports.cloudtasks_v2beta3 = v2beta3_1.cloudtasks_v2beta3;

var v1_29 = require("./apis/cloudtrace/v1");

exports.cloudtrace_v1 = v1_29.cloudtrace_v1;

var v2_10 = require("./apis/cloudtrace/v2");

exports.cloudtrace_v2 = v2_10.cloudtrace_v2;

var v1alpha1_3 = require("./apis/commentanalyzer/v1alpha1");

exports.commentanalyzer_v1alpha1 = v1alpha1_3.commentanalyzer_v1alpha1;

var v1_30 = require("./apis/composer/v1");

exports.composer_v1 = v1_30.composer_v1;

var v1beta1_13 = require("./apis/composer/v1beta1");

exports.composer_v1beta1 = v1beta1_13.composer_v1beta1;

var alpha_1 = require("./apis/compute/alpha");

exports.compute_alpha = alpha_1.compute_alpha;

var beta_1 = require("./apis/compute/beta");

exports.compute_beta = beta_1.compute_beta;

var v1_31 = require("./apis/compute/v1");

exports.compute_v1 = v1_31.compute_v1;

var v1_32 = require("./apis/container/v1");

exports.container_v1 = v1_32.container_v1;

var v1beta1_14 = require("./apis/container/v1beta1");

exports.container_v1beta1 = v1beta1_14.container_v1beta1;

var v1alpha1_4 = require("./apis/containeranalysis/v1alpha1");

exports.containeranalysis_v1alpha1 = v1alpha1_4.containeranalysis_v1alpha1;

var v1beta1_15 = require("./apis/containeranalysis/v1beta1");

exports.containeranalysis_v1beta1 = v1beta1_15.containeranalysis_v1beta1;

var v2_1_1 = require("./apis/content/v2.1");

exports.content_v2_1 = v2_1_1.content_v2_1;

var v2_11 = require("./apis/content/v2");

exports.content_v2 = v2_11.content_v2;

var v1_33 = require("./apis/customsearch/v1");

exports.customsearch_v1 = v1_33.customsearch_v1;

var v1b3_1 = require("./apis/dataflow/v1b3");

exports.dataflow_v1b3 = v1b3_1.dataflow_v1b3;

var v1beta1_16 = require("./apis/datafusion/v1beta1");

exports.datafusion_v1beta1 = v1beta1_16.datafusion_v1beta1;

var v1_34 = require("./apis/dataproc/v1");

exports.dataproc_v1 = v1_34.dataproc_v1;

var v1beta2_2 = require("./apis/dataproc/v1beta2");

exports.dataproc_v1beta2 = v1beta2_2.dataproc_v1beta2;

var v1_35 = require("./apis/datastore/v1");

exports.datastore_v1 = v1_35.datastore_v1;

var v1beta1_17 = require("./apis/datastore/v1beta1");

exports.datastore_v1beta1 = v1beta1_17.datastore_v1beta1;

var v1beta3_1 = require("./apis/datastore/v1beta3");

exports.datastore_v1beta3 = v1beta3_1.datastore_v1beta3;

var alpha_2 = require("./apis/deploymentmanager/alpha");

exports.deploymentmanager_alpha = alpha_2.deploymentmanager_alpha;

var v2_12 = require("./apis/deploymentmanager/v2");

exports.deploymentmanager_v2 = v2_12.deploymentmanager_v2;

var v2beta_1 = require("./apis/deploymentmanager/v2beta");

exports.deploymentmanager_v2beta = v2beta_1.deploymentmanager_v2beta;

var v3_3_1 = require("./apis/dfareporting/v3.3");

exports.dfareporting_v3_3 = v3_3_1.dfareporting_v3_3;

var v2_13 = require("./apis/dialogflow/v2");

exports.dialogflow_v2 = v2_13.dialogflow_v2;

var v2beta1_3 = require("./apis/dialogflow/v2beta1");

exports.dialogflow_v2beta1 = v2beta1_3.dialogflow_v2beta1;

var v1_36 = require("./apis/digitalassetlinks/v1");

exports.digitalassetlinks_v1 = v1_36.digitalassetlinks_v1;

var v1_37 = require("./apis/discovery/v1");

exports.discovery_v1 = v1_37.discovery_v1;

var v2_14 = require("./apis/dlp/v2");

exports.dlp_v2 = v2_14.dlp_v2;

var v1_38 = require("./apis/dns/v1");

exports.dns_v1 = v1_38.dns_v1;

var v1beta2_3 = require("./apis/dns/v1beta2");

exports.dns_v1beta2 = v1beta2_3.dns_v1beta2;

var v2beta1_4 = require("./apis/dns/v2beta1");

exports.dns_v2beta1 = v2beta1_4.dns_v2beta1;

var v1_39 = require("./apis/docs/v1");

exports.docs_v1 = v1_39.docs_v1;

var v1_40 = require("./apis/domainsrdap/v1");

exports.domainsrdap_v1 = v1_40.domainsrdap_v1;

var v1_41 = require("./apis/doubleclickbidmanager/v1");

exports.doubleclickbidmanager_v1 = v1_41.doubleclickbidmanager_v1;

var v2_15 = require("./apis/doubleclicksearch/v2");

exports.doubleclicksearch_v2 = v2_15.doubleclicksearch_v2;

var v2_16 = require("./apis/drive/v2");

exports.drive_v2 = v2_16.drive_v2;

var v3_5 = require("./apis/drive/v3");

exports.drive_v3 = v3_5.drive_v3;

var v2_17 = require("./apis/driveactivity/v2");

exports.driveactivity_v2 = v2_17.driveactivity_v2;

var v1alpha1_5 = require("./apis/factchecktools/v1alpha1");

exports.factchecktools_v1alpha1 = v1alpha1_5.factchecktools_v1alpha1;

var v1_42 = require("./apis/fcm/v1");

exports.fcm_v1 = v1_42.fcm_v1;

var v1_43 = require("./apis/file/v1");

exports.file_v1 = v1_43.file_v1;

var v1beta1_18 = require("./apis/file/v1beta1");

exports.file_v1beta1 = v1beta1_18.file_v1beta1;

var v1beta1_19 = require("./apis/firebase/v1beta1");

exports.firebase_v1beta1 = v1beta1_19.firebase_v1beta1;

var v1_44 = require("./apis/firebasedynamiclinks/v1");

exports.firebasedynamiclinks_v1 = v1_44.firebasedynamiclinks_v1;

var v1beta1_20 = require("./apis/firebasehosting/v1beta1");

exports.firebasehosting_v1beta1 = v1beta1_20.firebasehosting_v1beta1;

var v1_45 = require("./apis/firebaserules/v1");

exports.firebaserules_v1 = v1_45.firebaserules_v1;

var v1_46 = require("./apis/firestore/v1");

exports.firestore_v1 = v1_46.firestore_v1;

var v1beta1_21 = require("./apis/firestore/v1beta1");

exports.firestore_v1beta1 = v1beta1_21.firestore_v1beta1;

var v1beta2_4 = require("./apis/firestore/v1beta2");

exports.firestore_v1beta2 = v1beta2_4.firestore_v1beta2;

var v1_47 = require("./apis/fitness/v1");

exports.fitness_v1 = v1_47.fitness_v1;

var v1_48 = require("./apis/fusiontables/v1");

exports.fusiontables_v1 = v1_48.fusiontables_v1;

var v2_18 = require("./apis/fusiontables/v2");

exports.fusiontables_v2 = v2_18.fusiontables_v2;

var v1_49 = require("./apis/games/v1");

exports.games_v1 = v1_49.games_v1;

var v1configuration_1 = require("./apis/gamesConfiguration/v1configuration");

exports.gamesConfiguration_v1configuration = v1configuration_1.gamesConfiguration_v1configuration;

var v1management_1 = require("./apis/gamesManagement/v1management");

exports.gamesManagement_v1management = v1management_1.gamesManagement_v1management;

var v1_50 = require("./apis/genomics/v1");

exports.genomics_v1 = v1_50.genomics_v1;

var v1alpha2_2 = require("./apis/genomics/v1alpha2");

exports.genomics_v1alpha2 = v1alpha2_2.genomics_v1alpha2;

var v2alpha1_1 = require("./apis/genomics/v2alpha1");

exports.genomics_v2alpha1 = v2alpha1_1.genomics_v2alpha1;

var v1_51 = require("./apis/gmail/v1");

exports.gmail_v1 = v1_51.gmail_v1;

var v1_52 = require("./apis/groupsmigration/v1");

exports.groupsmigration_v1 = v1_52.groupsmigration_v1;

var v1_53 = require("./apis/groupssettings/v1");

exports.groupssettings_v1 = v1_53.groupssettings_v1;

var v1beta1_22 = require("./apis/healthcare/v1beta1");

exports.healthcare_v1beta1 = v1beta1_22.healthcare_v1beta1;

var v1_54 = require("./apis/homegraph/v1");

exports.homegraph_v1 = v1_54.homegraph_v1;

var v1_55 = require("./apis/iam/v1");

exports.iam_v1 = v1_55.iam_v1;

var v1_56 = require("./apis/iamcredentials/v1");

exports.iamcredentials_v1 = v1_56.iamcredentials_v1;

var v1_57 = require("./apis/iap/v1");

exports.iap_v1 = v1_57.iap_v1;

var v1beta1_23 = require("./apis/iap/v1beta1");

exports.iap_v1beta1 = v1beta1_23.iap_v1beta1;

var v3_6 = require("./apis/identitytoolkit/v3");

exports.identitytoolkit_v3 = v3_6.identitytoolkit_v3;

var v3_7 = require("./apis/indexing/v3");

exports.indexing_v3 = v3_7.indexing_v3;

var v2_19 = require("./apis/jobs/v2");

exports.jobs_v2 = v2_19.jobs_v2;

var v3_8 = require("./apis/jobs/v3");

exports.jobs_v3 = v3_8.jobs_v3;

var v3p1beta1_1 = require("./apis/jobs/v3p1beta1");

exports.jobs_v3p1beta1 = v3p1beta1_1.jobs_v3p1beta1;

var v1_58 = require("./apis/kgsearch/v1");

exports.kgsearch_v1 = v1_58.kgsearch_v1;

var v1_59 = require("./apis/language/v1");

exports.language_v1 = v1_59.language_v1;

var v1beta1_24 = require("./apis/language/v1beta1");

exports.language_v1beta1 = v1beta1_24.language_v1beta1;

var v1beta2_5 = require("./apis/language/v1beta2");

exports.language_v1beta2 = v1beta2_5.language_v1beta2;

var v1_60 = require("./apis/libraryagent/v1");

exports.libraryagent_v1 = v1_60.libraryagent_v1;

var v1_61 = require("./apis/licensing/v1");

exports.licensing_v1 = v1_61.licensing_v1;

var v2beta_2 = require("./apis/lifesciences/v2beta");

exports.lifesciences_v2beta = v2beta_2.lifesciences_v2beta;

var v2_20 = require("./apis/logging/v2");

exports.logging_v2 = v2_20.logging_v2;

var v1_62 = require("./apis/manufacturers/v1");

exports.manufacturers_v1 = v1_62.manufacturers_v1;

var v1_63 = require("./apis/mirror/v1");

exports.mirror_v1 = v1_63.mirror_v1;

var v1_64 = require("./apis/ml/v1");

exports.ml_v1 = v1_64.ml_v1;

var v1_65 = require("./apis/monitoring/v1");

exports.monitoring_v1 = v1_65.monitoring_v1;

var v3_9 = require("./apis/monitoring/v3");

exports.monitoring_v3 = v3_9.monitoring_v3;

var v1_66 = require("./apis/oauth2/v1");

exports.oauth2_v1 = v1_66.oauth2_v1;

var v2_21 = require("./apis/oauth2/v2");

exports.oauth2_v2 = v2_21.oauth2_v2;

var v1_67 = require("./apis/oslogin/v1");

exports.oslogin_v1 = v1_67.oslogin_v1;

var v1alpha_2 = require("./apis/oslogin/v1alpha");

exports.oslogin_v1alpha = v1alpha_2.oslogin_v1alpha;

var v1beta_3 = require("./apis/oslogin/v1beta");

exports.oslogin_v1beta = v1beta_3.oslogin_v1beta;

var v1_68 = require("./apis/pagespeedonline/v1");

exports.pagespeedonline_v1 = v1_68.pagespeedonline_v1;

var v2_22 = require("./apis/pagespeedonline/v2");

exports.pagespeedonline_v2 = v2_22.pagespeedonline_v2;

var v4_2 = require("./apis/pagespeedonline/v4");

exports.pagespeedonline_v4 = v4_2.pagespeedonline_v4;

var v5_1 = require("./apis/pagespeedonline/v5");

exports.pagespeedonline_v5 = v5_1.pagespeedonline_v5;

var v1_69 = require("./apis/people/v1");

exports.people_v1 = v1_69.people_v1;

var v1_70 = require("./apis/playcustomapp/v1");

exports.playcustomapp_v1 = v1_70.playcustomapp_v1;

var v1_71 = require("./apis/plus/v1");

exports.plus_v1 = v1_71.plus_v1;

var v1_72 = require("./apis/plusDomains/v1");

exports.plusDomains_v1 = v1_72.plusDomains_v1;

var v1beta_4 = require("./apis/policytroubleshooter/v1beta");

exports.policytroubleshooter_v1beta = v1beta_4.policytroubleshooter_v1beta;

var v1_73 = require("./apis/poly/v1");

exports.poly_v1 = v1_73.poly_v1;

var v1beta1_25 = require("./apis/proximitybeacon/v1beta1");

exports.proximitybeacon_v1beta1 = v1beta1_25.proximitybeacon_v1beta1;

var v1_74 = require("./apis/pubsub/v1");

exports.pubsub_v1 = v1_74.pubsub_v1;

var v1beta1a_1 = require("./apis/pubsub/v1beta1a");

exports.pubsub_v1beta1a = v1beta1a_1.pubsub_v1beta1a;

var v1beta2_6 = require("./apis/pubsub/v1beta2");

exports.pubsub_v1beta2 = v1beta2_6.pubsub_v1beta2;

var v1beta1_26 = require("./apis/recommender/v1beta1");

exports.recommender_v1beta1 = v1beta1_26.recommender_v1beta1;

var v1_75 = require("./apis/redis/v1");

exports.redis_v1 = v1_75.redis_v1;

var v1beta1_27 = require("./apis/redis/v1beta1");

exports.redis_v1beta1 = v1beta1_27.redis_v1beta1;

var v1_76 = require("./apis/remotebuildexecution/v1");

exports.remotebuildexecution_v1 = v1_76.remotebuildexecution_v1;

var v1alpha_3 = require("./apis/remotebuildexecution/v1alpha");

exports.remotebuildexecution_v1alpha = v1alpha_3.remotebuildexecution_v1alpha;

var v2_23 = require("./apis/remotebuildexecution/v2");

exports.remotebuildexecution_v2 = v2_23.remotebuildexecution_v2;

var v1beta1_28 = require("./apis/replicapool/v1beta1");

exports.replicapool_v1beta1 = v1beta1_28.replicapool_v1beta1;

var v1_77 = require("./apis/reseller/v1");

exports.reseller_v1 = v1_77.reseller_v1;

var v1_78 = require("./apis/run/v1");

exports.run_v1 = v1_78.run_v1;

var v1alpha1_6 = require("./apis/run/v1alpha1");

exports.run_v1alpha1 = v1alpha1_6.run_v1alpha1;

var v1beta1_29 = require("./apis/run/v1beta1");

exports.run_v1beta1 = v1beta1_29.run_v1beta1;

var v1_79 = require("./apis/runtimeconfig/v1");

exports.runtimeconfig_v1 = v1_79.runtimeconfig_v1;

var v1beta1_30 = require("./apis/runtimeconfig/v1beta1");

exports.runtimeconfig_v1beta1 = v1beta1_30.runtimeconfig_v1beta1;

var v4_3 = require("./apis/safebrowsing/v4");

exports.safebrowsing_v4 = v4_3.safebrowsing_v4;

var v1_80 = require("./apis/script/v1");

exports.script_v1 = v1_80.script_v1;

var v1_81 = require("./apis/searchconsole/v1");

exports.searchconsole_v1 = v1_81.searchconsole_v1;

var v1_82 = require("./apis/securitycenter/v1");

exports.securitycenter_v1 = v1_82.securitycenter_v1;

var v1beta1_31 = require("./apis/securitycenter/v1beta1");

exports.securitycenter_v1beta1 = v1beta1_31.securitycenter_v1beta1;

var v1p1alpha1_1 = require("./apis/securitycenter/v1p1alpha1");

exports.securitycenter_v1p1alpha1 = v1p1alpha1_1.securitycenter_v1p1alpha1;

var v1_83 = require("./apis/servicebroker/v1");

exports.servicebroker_v1 = v1_83.servicebroker_v1;

var v1alpha1_7 = require("./apis/servicebroker/v1alpha1");

exports.servicebroker_v1alpha1 = v1alpha1_7.servicebroker_v1alpha1;

var v1beta1_32 = require("./apis/servicebroker/v1beta1");

exports.servicebroker_v1beta1 = v1beta1_32.servicebroker_v1beta1;

var v1_84 = require("./apis/serviceconsumermanagement/v1");

exports.serviceconsumermanagement_v1 = v1_84.serviceconsumermanagement_v1;

var v1_85 = require("./apis/servicecontrol/v1");

exports.servicecontrol_v1 = v1_85.servicecontrol_v1;

var v1_86 = require("./apis/servicemanagement/v1");

exports.servicemanagement_v1 = v1_86.servicemanagement_v1;

var v1_87 = require("./apis/servicenetworking/v1");

exports.servicenetworking_v1 = v1_87.servicenetworking_v1;

var v1beta_5 = require("./apis/servicenetworking/v1beta");

exports.servicenetworking_v1beta = v1beta_5.servicenetworking_v1beta;

var v1_88 = require("./apis/serviceusage/v1");

exports.serviceusage_v1 = v1_88.serviceusage_v1;

var v1beta1_33 = require("./apis/serviceusage/v1beta1");

exports.serviceusage_v1beta1 = v1beta1_33.serviceusage_v1beta1;

var v4_4 = require("./apis/sheets/v4");

exports.sheets_v4 = v4_4.sheets_v4;

var v1_89 = require("./apis/siteVerification/v1");

exports.siteVerification_v1 = v1_89.siteVerification_v1;

var v1_90 = require("./apis/slides/v1");

exports.slides_v1 = v1_90.slides_v1;

var v1_91 = require("./apis/sourcerepo/v1");

exports.sourcerepo_v1 = v1_91.sourcerepo_v1;

var v1_92 = require("./apis/spanner/v1");

exports.spanner_v1 = v1_92.spanner_v1;

var v1_93 = require("./apis/speech/v1");

exports.speech_v1 = v1_93.speech_v1;

var v1p1beta1_1 = require("./apis/speech/v1p1beta1");

exports.speech_v1p1beta1 = v1p1beta1_1.speech_v1p1beta1;

var v2beta1_5 = require("./apis/speech/v2beta1");

exports.speech_v2beta1 = v2beta1_5.speech_v2beta1;

var v1beta4_1 = require("./apis/sql/v1beta4");

exports.sql_v1beta4 = v1beta4_1.sql_v1beta4;

var v1beta4_2 = require("./apis/sqladmin/v1beta4");

exports.sqladmin_v1beta4 = v1beta4_2.sqladmin_v1beta4;

var v1_94 = require("./apis/storage/v1");

exports.storage_v1 = v1_94.storage_v1;

var v1beta1_34 = require("./apis/storage/v1beta1");

exports.storage_v1beta1 = v1beta1_34.storage_v1beta1;

var v1beta2_7 = require("./apis/storage/v1beta2");

exports.storage_v1beta2 = v1beta2_7.storage_v1beta2;

var v1_95 = require("./apis/storagetransfer/v1");

exports.storagetransfer_v1 = v1_95.storagetransfer_v1;

var v1_96 = require("./apis/streetviewpublish/v1");

exports.streetviewpublish_v1 = v1_96.streetviewpublish_v1;

var v2_24 = require("./apis/surveys/v2");

exports.surveys_v2 = v2_24.surveys_v2;

var v1_97 = require("./apis/tagmanager/v1");

exports.tagmanager_v1 = v1_97.tagmanager_v1;

var v2_25 = require("./apis/tagmanager/v2");

exports.tagmanager_v2 = v2_25.tagmanager_v2;

var v1_98 = require("./apis/tasks/v1");

exports.tasks_v1 = v1_98.tasks_v1;

var v1_99 = require("./apis/testing/v1");

exports.testing_v1 = v1_99.testing_v1;

var v1_100 = require("./apis/texttospeech/v1");

exports.texttospeech_v1 = v1_100.texttospeech_v1;

var v1beta1_35 = require("./apis/texttospeech/v1beta1");

exports.texttospeech_v1beta1 = v1beta1_35.texttospeech_v1beta1;

var v1beta3_2 = require("./apis/toolresults/v1beta3");

exports.toolresults_v1beta3 = v1beta3_2.toolresults_v1beta3;

var v1_101 = require("./apis/tpu/v1");

exports.tpu_v1 = v1_101.tpu_v1;

var v1alpha1_8 = require("./apis/tpu/v1alpha1");

exports.tpu_v1alpha1 = v1alpha1_8.tpu_v1alpha1;

var v2_26 = require("./apis/translate/v2");

exports.translate_v2 = v2_26.translate_v2;

var v3beta1_1 = require("./apis/translate/v3beta1");

exports.translate_v3beta1 = v3beta1_1.translate_v3beta1;

var v1_102 = require("./apis/vault/v1");

exports.vault_v1 = v1_102.vault_v1;

var v1_103 = require("./apis/verifiedaccess/v1");

exports.verifiedaccess_v1 = v1_103.verifiedaccess_v1;

var v1_104 = require("./apis/videointelligence/v1");

exports.videointelligence_v1 = v1_104.videointelligence_v1;

var v1beta2_8 = require("./apis/videointelligence/v1beta2");

exports.videointelligence_v1beta2 = v1beta2_8.videointelligence_v1beta2;

var v1p1beta1_2 = require("./apis/videointelligence/v1p1beta1");

exports.videointelligence_v1p1beta1 = v1p1beta1_2.videointelligence_v1p1beta1;

var v1p2beta1_1 = require("./apis/videointelligence/v1p2beta1");

exports.videointelligence_v1p2beta1 = v1p2beta1_1.videointelligence_v1p2beta1;

var v1p3beta1_1 = require("./apis/videointelligence/v1p3beta1");

exports.videointelligence_v1p3beta1 = v1p3beta1_1.videointelligence_v1p3beta1;

var v1_105 = require("./apis/vision/v1");

exports.vision_v1 = v1_105.vision_v1;

var v1p1beta1_3 = require("./apis/vision/v1p1beta1");

exports.vision_v1p1beta1 = v1p1beta1_3.vision_v1p1beta1;

var v1p2beta1_2 = require("./apis/vision/v1p2beta1");

exports.vision_v1p2beta1 = v1p2beta1_2.vision_v1p2beta1;

var v1_106 = require("./apis/webfonts/v1");

exports.webfonts_v1 = v1_106.webfonts_v1;

var v3_10 = require("./apis/webmasters/v3");

exports.webmasters_v3 = v3_10.webmasters_v3;

var v1_107 = require("./apis/websecurityscanner/v1");

exports.websecurityscanner_v1 = v1_107.websecurityscanner_v1;

var v1alpha_4 = require("./apis/websecurityscanner/v1alpha");

exports.websecurityscanner_v1alpha = v1alpha_4.websecurityscanner_v1alpha;

var v1beta_6 = require("./apis/websecurityscanner/v1beta");

exports.websecurityscanner_v1beta = v1beta_6.websecurityscanner_v1beta;

var v3_11 = require("./apis/youtube/v3");

exports.youtube_v3 = v3_11.youtube_v3;

var v1_108 = require("./apis/youtubeAnalytics/v1");

exports.youtubeAnalytics_v1 = v1_108.youtubeAnalytics_v1;

var v2_27 = require("./apis/youtubeAnalytics/v2");

exports.youtubeAnalytics_v2 = v2_27.youtubeAnalytics_v2;

var v1_109 = require("./apis/youtubereporting/v1");

exports.youtubereporting_v1 = v1_109.youtubereporting_v1;